import { useMemo } from 'react';
import type { AccessRule } from './access-rule';
import { checkRules } from '../lib/check-rules';
import { useUserRules } from './use-user-rules';

export const useRulesAccess = (rule: AccessRule | undefined) => {
  const { data } = useUserRules();

  return useMemo(() => checkRules(rule, data), [rule, data]);
};